import { ALLIANZ_VARS, MEDIA_QUERIES, URL_VISITED, URL_WITHOUT_RINGPOOL } from '../config'

export function createRingpoolElement({ number }) {
  if (URL_WITHOUT_RINGPOOL.includes(URL_VISITED)) return

  const SELECTORS_DOM = {
    DESKTOP: {
      BTN_REQUEST_BUDGET: '.c-header-metabar__service-link',
      HEADER_WRAP: '.c-header-metabar__content.c-header__wrapper',
      VOID_DIV: '.c-header-metabar__target.c-header-metabar__target--tab',
      HEADER_CTA: '.c-header__service__link--desktop',
      LOGIN: '.c-header-metabar__user.c-header-metabar__user--login'
    },
    MOBILE: {
      HEADER_WRAP: '.c-header__navigation.c-navigation__menu-wrapper',
      MENU: '.c-navigation__opener'
    }
  }

  const ringPoolWrap = document.createElement('div')
  ringPoolWrap.classList.add('ringpool-wrap')
  ringPoolWrap.style.display = 'none'

  setTimeout(() => {
    ringPoolWrap.style.display = 'flex'
  }, 1000)

  const iconTel = document.createElement('img')
  iconTel.src = ALLIANZ_VARS.paths.iconTel
  iconTel.classList.add('ringpool-icon')

  const ringpool = document.createElement('a')
  ringpool.classList.add('drp-phone-new', 'wal-drp-phone', 'ringpool-number', 'drp-phone')
  ringpool.setAttribute('href', `tel:${number}`)
  ringpool.innerText = number

  ringPoolWrap.appendChild(iconTel)
  ringPoolWrap.appendChild(ringpool)

  const $loginExist = document.querySelector(SELECTORS_DOM.DESKTOP.LOGIN)
  const $isNotMenu = document.querySelector(SELECTORS_DOM.MOBILE.MENU)
  const isNotLandingType = $loginExist !== null
  const isNotMenu = $isNotMenu !== null
  const $textFromHeaderCta = document.querySelector(SELECTORS_DOM.DESKTOP.HEADER_CTA)?.textContent

  const insertRingpool = (selector) => {
    const $elementToInsertRingpool = document.querySelector(selector)
    $elementToInsertRingpool.appendChild(ringPoolWrap)
  }

  if (window.innerWidth >= MEDIA_QUERIES.tablet && isNotLandingType) {
    insertRingpool(SELECTORS_DOM.DESKTOP.VOID_DIV)
    return
  }

  if (window.innerWidth >= MEDIA_QUERIES.tablet && $textFromHeaderCta === 'Request a call') {
    insertRingpool(SELECTORS_DOM.DESKTOP.VOID_DIV)
    return
  }

  if (window.innerWidth >= MEDIA_QUERIES.tablet && !isNotLandingType) {
    insertRingpool(SELECTORS_DOM.DESKTOP.HEADER_WRAP)
    return
  }

  if (window.innerWidth <= MEDIA_QUERIES.tablet && !isNotLandingType && !isNotMenu) {
    insertRingpool(SELECTORS_DOM.MOBILE.HEADER_WRAP)
  }
}
